import { RouteMap } from 'constants/Routes';

const getDefaultDrugPageLink = (slug: string): string => {
  return `${RouteMap.DRUG.base}${slug}`;
};

export default getDefaultDrugPageLink;
